var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-wrap"},[_c('img',{attrs:{"src":require("@/assets/img/wrong-sign.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t("lang.PageUnavailable")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }